<template>
  <div v-if="loading || hasAdvertisements" class="anz-main-page-slider-wrapper">
    <!-- Skeleton Loading -->
    <div v-if="loading" class="slider-skeleton">
      <div class="skeleton-image"></div>
      <div class="skeleton-content">
        <div class="slider-copy">
          <div class="skeleton-title"></div>
          <div class="skeleton-text"></div>
        </div>
        <div class="skeleton-btn"></div>
      </div>
    </div>

    <!-- Actual Slider -->
    <div v-else
         :uk-slider="`autoplay: true; autoplay-interval: ${autoPlayTime}`"
         class="anz-main-page-slider uk-position-relative uk-visible-toggle uk-light dashboard-banner-slider"
         tabindex="-1">
      <ul id="dashboard" class="uk-slider-items uk-grid">
        <li v-for="(item, index) in advertisements" :key="'ad_slider_list_item_' + index"
            class="uk-width-1-1">
          <div class="slider-item">
            <div class="slider-image-wrapper">
              <template v-if="item.image_link">
                <img :src="item.image_link" alt="" aria-hidden="true" class="slider-image-backdrop">
                <img :src="item.image_link" :alt="item.name || 'Banner'" class="slider-image">
              </template>
            </div>

            <div class="slider-content">
              <div v-if="item.name || item.text" class="slider-copy">
                <h2 v-if="item.name" class="slider-title">{{ item.name }}</h2>
                <p v-if="item.text" class="slider-text">{{ item.text }}</p>
              </div>
              <a v-if="item.url || item.button_text"
                 :href="item.url"
                 :target="item.is_new_tab ? '_blank' : '_self'"
                 class="slider-btn">
                {{ item.button_text }}
              </a>
            </div>
          </div>
        </li>
      </ul>

      <!-- Navigation Arrows -->
      <a class="slider-nav slider-nav-prev uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
      <a class="slider-nav slider-nav-next uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "anz-main-page-slider",
  props: {
    advertisements: {
      type: Array,
      default: () => []
    },
    autoPlayTime: {
      type: Number,
      default: 4000
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasAdvertisements() {
      return this.advertisements && this.advertisements.length > 0;
    }
  }
}
</script>

<style scoped>
/* Banner ölçüsü: desktop 1920x410 tam gösterim, mobilde daha yüksek kutu */
.anz-main-page-slider-wrapper {
  --slider-aspect-ratio: 1920 / 410;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Skeleton Styles */
.slider-skeleton {
  position: relative;
  width: 100%;
  aspect-ratio: var(--slider-aspect-ratio);
  overflow: hidden;
  background: #e9ecef;
}

.skeleton-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-content {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  padding: 2rem 4rem;
  width: 50%;
  max-width: 500px;
}

.skeleton-title {
  width: 80%;
  height: 2.5rem;
  background: linear-gradient(90deg, rgba(255,255,255,0.3) 25%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0.3) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.skeleton-text {
  width: 100%;
  height: 1rem;
  background: linear-gradient(90deg, rgba(255,255,255,0.3) 25%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0.3) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.skeleton-text-short {
  width: 60%;
}

.skeleton-btn {
  width: 140px;
  height: 44px;
  background: linear-gradient(90deg, rgba(255,255,255,0.3) 25%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0.3) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin-top: 0.5rem;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Slider Wrapper */
.anz-main-page-slider {
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.anz-main-page-slider .uk-slider-items {
  margin: 0 !important;
  padding: 0 !important;
}

.anz-main-page-slider .uk-slider-items > li {
  margin: 0 !important;
  padding: 0 !important;
}

.slider-item {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
}

.slider-image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: var(--slider-aspect-ratio, 1920 / 410);
  overflow: hidden;
  margin: 0;
  padding: 0;
  line-height: 0;
  background: #e9ecef;
}

/* Resim oranı kutu oranıyla uyuşmadığında (eski 1920x410 dışı bannerlar,
   mobil kutu oranı) boşluğu aynı resmin blur'lu kopyası doldurur:
   resim hiçbir kırpılmaya uğramaz, kenarlarda gri bant görünmez. */
.slider-image-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  /* scale: blur'un kenarlardaki şeffaf geçişini kutu dışına taşır */
  transform: scale(1.15);
  filter: blur(24px) saturate(1.15);
  pointer-events: none;
  z-index: 0;
}

.slider-image {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
  margin: 0;
  padding: 0;
}

.slider-content {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  padding: 2rem 4rem;
  max-width: 60%;
  text-align: left;
  z-index: 1;
  box-sizing: border-box;
}

.slider-copy {
  min-width: 0;
}

.slider-title {
  font-size: clamp(1.25rem, 3vw, 2.5rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.75rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
}

.slider-text {
  font-size: clamp(0.875rem, 1.5vw, 1.125rem);
  color: #fff;
  margin-bottom: 1.25rem;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.slider-btn {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: rgba(0, 51, 102, 0.9);
  color: #fff;
  text-decoration: none;
  border-radius: 6px;
  font-size: clamp(0.875rem, 1.2vw, 1rem);
  font-weight: 500;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.slider-btn:hover {
  background-color: rgba(0, 51, 102, 1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  color: #fff;
}

/* Navigation Arrows */
.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all 0.3s ease;
}

.slider-nav:hover {
  background: rgba(255, 255, 255, 0.4);
}

.slider-nav-prev {
  left: 1rem;
}

.slider-nav-next {
  right: 1rem;
}

/* Dots Navigation */
.slider-dots {
  margin-top: 1rem;
  padding: 0.5rem 0;
}

/* Tablet */
@media (max-width: 1024px) {
  .slider-content {
    padding: 1.25rem 2rem;
    max-width: 70%;
  }

  .slider-nav {
    padding: 0.75rem;
  }

  .slider-nav-prev {
    left: 0.75rem;
  }

  .slider-nav-next {
    right: 0.75rem;
  }

  .skeleton-content {
    width: 55%;
    padding: 1.25rem 2rem;
  }
}

/* Mobile — yazılar sol üst, buton sağ alt */
@media (max-width: 768px) {
  .anz-main-page-slider-wrapper {
    --slider-aspect-ratio: 12 / 5;
    --slider-touch-min: 44px;
  }

  /* Mobilde de contain: kutu oranı 1920/410'dan farklı olduğu için
     cover kullanılırsa bannerın alt/üstü kesilir. */
  .slider-image {
    object-fit: contain;
    object-position: center center;
  }

  /* Dar ekranda blur dolgu daha az alan kapladığı için yumuşatmayı azalt */
  .slider-image-backdrop {
    transform: scale(1.2);
    filter: blur(16px) saturate(1.15);
  }

  .slider-item {
    overflow: visible;
  }

  .slider-content {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    width: 100%;
    max-width: 100%;
    min-height: 0;
    height: 100%;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    overflow: visible;
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.18) 38%,
      transparent 62%
    );
  }

  .slider-copy {
    align-self: flex-start;
    max-width: 78%;
    padding-right: 4px;
  }

  .slider-title {
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25;
    margin: 0 0 3px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-shadow:
      0 1px 2px rgba(0, 0, 0, 0.95),
      0 2px 10px rgba(0, 0, 0, 0.65);
  }

  .slider-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin: 0;
    font-size: 0.6875rem;
    line-height: 1.35;
    color: rgba(255, 255, 255, 0.95);
    text-shadow:
      0 1px 2px rgba(0, 0, 0, 0.9),
      0 2px 8px rgba(0, 0, 0, 0.6);
  }

  .slider-btn {
    align-self: flex-end;
    margin-top: auto;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    min-height: var(--slider-touch-min);
    min-width: var(--slider-touch-min);
    max-width: calc(100% - 4px);
    font-size: 0.8125rem;
    font-weight: 600;
    line-height: 1.2;
    border-radius: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
    z-index: 2;
  }

  .slider-btn:active {
    transform: scale(0.96);
    opacity: 0.92;
  }

  .slider-btn:hover {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
  }

  .slider-nav {
    display: none;
  }

  .slider-dots {
    margin-top: 0;
    padding: 0;
  }

  .skeleton-content {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 0;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.35) 0%,
      transparent 55%
    );
  }

  .skeleton-content .slider-copy {
    max-width: 78%;
  }

  .skeleton-title {
    height: 0.875rem;
    width: 72%;
    margin-bottom: 6px;
  }

  .skeleton-text {
    display: block;
    height: 0.625rem;
    width: 88%;
    margin-bottom: 0;
  }

  .skeleton-btn {
    align-self: flex-end;
    margin-top: auto;
    width: 96px;
    height: var(--slider-touch-min);
    min-height: var(--slider-touch-min);
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .anz-main-page-slider-wrapper {
    --slider-aspect-ratio: 5 / 2;
  }

  .slider-content {
    padding: 8px 10px;
  }

  .slider-copy {
    max-width: 80%;
  }

  .slider-title {
    font-size: 0.8125rem;
  }

  .slider-text {
    font-size: 0.625rem;
  }

  .slider-btn {
    padding: 10px 12px;
    font-size: 0.75rem;
  }
}

@media (max-width: 400px) {
  .slider-copy {
    max-width: 82%;
  }

  .slider-title {
    font-size: 0.75rem;
  }

  .slider-text {
    font-size: 0.5625rem;
  }

  .slider-btn {
    font-size: 0.6875rem;
  }
}
</style>
